<div class="service-center-area">
  <div class="d-flex flex-column">

    <div class="l2-title">Basic</div>

    <div class="item-row mb-8px">
      <div class="item-label top">Service Center</div>
      <div class="item-value">
        <div>{{ ticketInfo?.ascNo }}</div>
        <div>{{ constants.dummyASCs.includes(ticketInfo?.ascNo) ? 'Pending Servicer Assignment' : ticketInfo?.serviceCenter?.name }}</div>
        <div *ngIf="ticketInfo?.serviceCenter?.tel && !constants.dummyASCs.includes(ticketInfo?.ascNo)">
          {{ ticketInfo?.serviceCenter?.tel | telNoCountry }}
        </div>
      </div>
    </div>

    <ng-container *ngIf="[companies.Sea, companies.Seca].includes(company)">
      <div class="item-row mb-8px">
        <div class="item-label">Assign Date</div>
        <div class="item-value">{{ ticketInfo?.assignDate | hqDateOptionalTime }}</div>
      </div>

      <div class="item-row mb-8px">
        <div class="item-label">Ack Date</div>
        <div class="item-value">{{ ticketInfo?.ackDate | hqDateOptionalTime }}</div>
      </div>

      <div class="item-row mb-8px">
        <div class="item-label">1st App.</div>
        <div class="item-value">
          <ng-container *ngIf="ticketInfo?.firstScheduleDate">
            <span>{{ ticketInfo?.firstScheduleDate | hqDateOptionalTime }}</span>
          </ng-container>
        </div>
      </div>

      <div class="item-row mb-8px">
        <div class="item-label">Last App.</div>
        <div class="item-value">
          <ng-container *ngIf="ticketInfo?.scheduleDate">
            <span>{{ ticketInfo?.scheduleDate | hqDateOptionalTime }}</span>
          </ng-container>
        </div>
      </div>
      <div class="item-row mb-8px" *ngIf="ticketInfo?.repairDesc">
        <div class="item-label">Repair Desc</div>
        <div class="item-value">
            <span>{{ ticketInfo?.repairDesc }}</span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="[companies.SeaIm].includes(company)">
      <div class="item-row mb-8px">
        <div class="item-label">Received Date</div>
        <div class="item-value">{{ ticketInfo?.receiveDate | hqDateOptionalTime }}</div>
      </div>

      <div class="item-row mb-8px">
        <div class="item-label">Shipped Date</div>
        <div class="item-value">{{ ticketInfo?.shipDate | hqDateOptionalTime }}</div>
      </div>

      <div class="item-row mb-8px">
        <div class="item-label">Completed Date</div>
        <div class="item-value">{{ ticketInfo?.completeDate | hqDateOptionalTime }}</div>
      </div>
    </ng-container>

    <!--    <div class="item-row mb-8px">-->
    <!--      <div class="item-label">ASC Job</div>-->
    <!--      <div class="item-value">{{ticketInfo?.ascJobNo}}</div>-->
    <!--    </div>-->

    <div *ngIf="[companies.Sea, companies.Seca].includes(company) || ([companies.SeaIm].includes(company) && isAdmin)"
         class="pt-10px">

      <div class="dot-horizontal-line"></div>
      <div class="l2-title">Parts</div>
      <div *ngFor="let part of ticketInfo?.parts; let last = last" [ngClass]="{'bb': !last}">
        <div class="item-row">
          <div class="item-label">Part Status</div>
          <div class="item-value">{{ part.partStatus }}</div>
        </div>

        <div class="item-row">
          <div class="item-label">Part #</div>
          <div class="item-value">{{ part.partNo }}</div>
        </div>

        <div class="item-row">
          <div class="item-label">Tracking #</div>
          <div class="item-value">
            <a [href]="part.trackingUrl" class="url-link" target="_blank">{{ part.trackingNo }}</a>
            <span *ngIf="!part.trackingUrl">{{ part.trackingNo }}</span>
          </div>
        </div>

        <div class="item-row">
          <div class="item-label">PO #</div>
          <div class="item-value">{{ part.poNo }}</div>
        </div>

        <div class="item-row">
          <div class="item-label">PO Status</div>
          <div class="item-value">{{ part.poStatus }}</div>
        </div>

        <div class="item-row">
          <div class="item-label">Description</div>
          <div class="item-value">{{ part.description }}</div>
        </div>
      </div>
      <div *ngIf="!ticketInfo?.parts?.length" class="n-a">N/A</div>

      <div class="dot-horizontal-line"></div>

      <div class="l2-title">SAW</div>
      <div *ngFor="let saw of ticketInfo?.saws; let last = last" [ngClass]="{'bb': !last}">
        <div class="item-row">
          <div class="item-label">SAW #</div>
          <div class="item-value">{{ saw.sawNo }}</div>
        </div>

        <div class="item-row">
          <div class="item-label">Status</div>
          <div class="item-value">{{ saw.status.concat(saw.statusName ? ': '.concat(saw.statusName) : '') }}</div>
        </div>

        <div class="item-row">
          <div class="item-label">Req Type</div>
          <div class="item-value">{{ saw.reqType.concat(saw.reqType ? ': '.concat(saw.reqTypeName) : '') }}</div>
        </div>

        <div class="item-row">
          <div class="item-label">Requester</div>
          <div class="item-value">{{ saw.requester }}</div>
        </div>

        <div class="item-row">
          <div class="item-label">Confirm User</div>
          <div class="item-value">{{ saw.confirmUser }}</div>
        </div>

        <div class="item-row">
          <div class="item-label">Request Date</div>
          <div class="item-value">{{ saw.requestDate | hqDateOptionalTime }}</div>
        </div>

        <div class="item-row">
          <div class="item-label">Confirm Date</div>
          <div class="item-value">{{ saw.confirmDate | hqDateOptionalTime }}</div>
        </div>

        <div class="item-row">
          <div class="item-label">Mileage</div>
          <div class="item-value">{{ saw.mileage || 0 }}mi</div>
        </div>

        <div class="item-row">
          <div class="item-label">Confirm Mileage</div>
          <div class="item-value">{{ saw.confirmMileage || 0 }}</div>
        </div>

        <!--        <div class="item-row">-->
        <!--          <div class="item-label">Amount</div>-->
        <!--          <div class="item-value">${{(saw.amount || 0) | number : '1.2-2'}}</div>-->
        <!--        </div>-->

        <div class="item-row">
          <div class="item-label">Confirm Comment</div>
          <div class="item-value">{{ saw.confirmComment }}</div>
        </div>
      </div>
      <div *ngIf="!ticketInfo?.saws?.length" class="n-a">N/A</div>

      <ng-container *ngIf="ticketInfo?.serviceType === pickUpService && ticketInfo?.shipments?.inbound">
        <div class="dot-horizontal-line"></div>
        <div class="l2-title">Shipping to Service Center</div>
        <div>
          <div class="item-row">
            <div class="item-label">Tracking #</div>
            <div class="item-value link-primary text-decoration-underline">
              <a [href]="inboundTrackingUrl" target="_blank">
                {{ ticketInfo?.shipments?.inbound }}
              </a>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="ticketInfo?.serviceType === pickUpService && ticketInfo?.shipments?.outbound">
        <div class="dot-horizontal-line"></div>
        <div class="l2-title">Shipping to Customer</div>
        <div>
          <div class="item-row">
            <div class="item-label">Tracking #</div>
            <div class="item-value link-primary text-decoration-underline">
              <a [href]="outboundTrackingUrl" target="_blank">
                {{ ticketInfo?.shipments?.outbound }}
              </a>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div *ngIf="[companies.Sea, companies.Seca].includes(company) || ([companies.SeaIm].includes(company) && isAdmin)"
     class="ticket-horizontal-line"></div>

<div *ngIf="[companies.Sea, companies.Seca].includes(company) || ([companies.SeaIm].includes(company) && isAdmin)"
     class="change-logs-wrapper">
  <div class="l1-title">Change Logs</div>
  <div class="change-logs-area">
    <div *ngFor="let changeLog of changeLogs" class="row">
      <div class="col-12 py-2 bb">
        <div class="row">
          <div class="col-6 col-md-4">
            {{ changeLog.changeDate | hqDateTime }}
          </div>
          <div class="col-6 col-md-3">
            {{ changeLog.ascNo }}
          </div>
          <div class="col-6 col-md-2">
            <dp-status-badge [status]="changeLog.status"></dp-status-badge>
          </div>
          <div class="col-6 col-md-3">
            {{ changeLog.changedBy }}
          </div>
        </div>
        <div *ngIf="changeLog.reason" class="row pt-2">
          <div class="col-6 col-md-8 offset-md-4">
            <i class="text-muted mr-2">Reason:</i>
            {{ changeLog.reason }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

